import React from 'react';
import { motion } from 'framer-motion';

const MidCTA: React.FC = () => {
  return (
    <div className="py-20 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="max-w-4xl mx-auto rounded-2xl border border-[#3B82F6]/15 bg-gradient-to-r from-[#3B82F6]/5 to-[#8B5CF6]/5 p-10 sm:p-14 text-center"
      >
        <h3 className="font-space-grotesk text-2xl sm:text-3xl font-bold text-white mb-4">
          Ready to build one of these?
        </h3>
        <p className="text-[#A1A1AA]/60 text-sm mb-8 max-w-lg mx-auto leading-relaxed">
          Each vertical is an open seat for a founding team. Joint venture equity, revenue sharing, and 2,400 dealerships from day one.
        </p>
        <a
          href="#footer-cta"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('footer-cta')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#3B82F6] text-white font-medium text-sm hover:bg-[#2563EB] transition-colors"
        >
          Become a Builder in Residence
        </a>
      </motion.div>
    </div>
  );
};

export default MidCTA;
